import api from './api';

const triageService = {
  // Get all triage actions with filters
  getTriageActions: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/triage/?${queryString}`);
    return response.data;
  },

  // Get triage stats
  getStats: async () => {
    const response = await api.get('/triage/stats');
    return response.data;
  },

  // Get single triage action
  getTriageAction: async (actionId) => {
    const response = await api.get(`/triage/${actionId}`);
    return response.data;
  },

  // Create triage action
  createTriageAction: async (actionData) => {
    const response = await api.post('/triage/', actionData);
    return response.data;
  },

  // Update triage action
  updateTriageAction: async (actionId, actionData) => {
    const response = await api.put(`/triage/${actionId}`, actionData);
    return response.data;
  },

  // Delete triage action
  deleteTriageAction: async (actionId) => {
    const response = await api.delete(`/triage/${actionId}`);
    return response.data;
  },

  // Mark action as complete
  completeAction: async (actionId) => {
    const response = await api.patch(`/triage/${actionId}/complete`);
    return response.data;
  },

  // Reopen completed action
  reopenAction: async (actionId) => {
    const response = await api.patch(`/triage/${actionId}/reopen`);
    return response.data;
  },

  // Get triage actions for a specific case
  getActionsForCase: async (caseId, includeCompleted = false) => {
    const response = await api.get(`/triage/case/${caseId}?include_completed=${includeCompleted}`);
    return response.data;
  },

  // Get pending triage count for a case (used when closing)
  getPendingCountForCase: async (caseId) => {
    const response = await api.get(`/triage/case/${caseId}/pending-count`);
    return response.data;
  },

  // Delete all triage entries for a case
  deleteAllForCase: async (caseId) => {
    const response = await api.delete(`/triage/case/${caseId}/all`);
    return response.data;
  },

  // Get open cases for dropdown
  getOpenCases: async () => {
    const response = await api.get('/triage/cases/open');
    return response.data;
  },

  // Sync all active cases to triage
  syncCases: async () => {
    const response = await api.post('/triage/sync-cases');
    return response.data;
  }
};

export default triageService;
